<template>
    <div>
        <b-card
            header="Providers"
            header-text-variant="white"
            header-bg-variant="info"
        >
            <div class="table-responsive">
                <b-table :items="items" :fields="fields">
                    <template v-slot:cell(action)="row">
                        <b-btn variant="info" @click="editContactInfo(row.item)" v-if="!isEnrolled(row.item.enrollment_status)">
                            Change Contact Info
                        </b-btn>
                        <b-btn variant="info" @click="editProvider(row.item)">
                            Change Rate
                        </b-btn>
                    </template>
                </b-table>
            </div>
        </b-card>

        <b-modal :title="providerModalTitle"
                 v-model="providerModal"
        >
            <b-container fluid>
                <b-row>
                    <b-col lg="12">
                        <b-form-group label="Hourly Rate" label-for="caregiver_hourly_rate">
                            <b-form-input type="number"
                                          step="any"
                                          v-model="form.caregiver_hourly_rate"
                            />
                            <input-help :form="form" field="caregiver_hourly_rate" text="Enter the agreed upon hourly rate for this provider"/>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-container>
            <div slot="modal-footer">
                <b-btn variant="info" @click="updateProvider()" :disabled="busy">Save</b-btn>
                <b-btn variant="default" @click="providerModal = false" :disabled="busy">Close</b-btn>
            </div>
        </b-modal>

        <b-modal title="Update Contact Info"
                 v-model="contactModal"
        >
            <b-container fluid>
                <b-row>
                    <b-col lg="12">
                        <b-form-group label="Email Address" label-for="email">
                            <b-form-input type="email"
                                          step="any"
                                          v-model="form.email"
                            />
                            <input-help :form="form" field="email" text=""/>
                        </b-form-group>
                        <b-form-group label="Phone Number" label-for="phone">
                            <mask-input v-model="form.phone" name="phone" id="phone"></mask-input>
                            <input-help :form="form" field="phone" text=""/>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-container>
            <div slot="modal-footer">
                <b-btn variant="info" @click="updateContactInfo()" :disabled="busy">Save</b-btn>
                <b-btn variant="default" @click="contactModal = false" :disabled="busy">Close</b-btn>
            </div>
        </b-modal>
    </div>
</template>

<script>
import EnrollmentStatuses from "../../mixins/EnrollmentStatuses";
import FormatsListData from "../../mixins/FormatsListData";
import FormatsNumbers from "../../mixins/FormatsNumbers";

export default {
    mixins: [EnrollmentStatuses, FormatsListData, FormatsNumbers],

    props: {
        client: {}
    },

    data() {
        return {
            busy: false,
            form: new Form({}),
            providerModal: false,
            contactModal: false,
            selectedProvider: {},
            items: this.mapItems(this.client.caregivers),
            fields: [
                "name",
                {
                    key: 'rate',
                    formatter: val => this.moneyFormat(val),
                },
                {
                    key: 'email',
                },
                "phone",
                {
                    key: 'enrollment_status',
                    formatter: (val) => this.isEnrolled(val) ? 'Enrolled' : 'Not Enrolled',
                },
                "action",
            ]
        };
    },

    computed: {
        providerModalTitle() {
            if (this.selectedProvider) {
                return `Edit Rate for ${this.selectedProvider.name}`;
            } else {
                return 'Edit Provider';
            }
        }
    },

    methods: {
        mapItems(items) {
            return items.map(caregiver => {
                caregiver.email = this.formatEmail(caregiver.email);
                caregiver.rate = caregiver.pivot.caregiver_hourly_rate;
                caregiver.phone = caregiver.phone_numbers.length ? caregiver.phone_numbers[0].number : '';
                return caregiver;
            });
        },

        editProvider(provider) {
            this.selectedProvider = provider;

            this.form = new Form({
                caregiver_hourly_rate: provider.pivot.caregiver_hourly_rate,
            });

            this.providerModal = true;
        },

        updateProvider() {
            this.busy = true;
            this.form.put(`/caregivers/${this.selectedProvider.id}`)
                .then( ({ data }) => {
                    this.items = this.mapItems(data.data);
                    this.providerModal = false;
                    this.busy = false;
                })
                .catch(e => {
                    console.log(e);
                    this.busy = false;
                })
        },

        editContactInfo(provider) {
            this.selectedProvider = provider;
            this.form = new Form({
                email: provider.email,
                phone: provider.phone,
            });
            this.contactModal = true;
        },

        updateContactInfo() {
            this.busy = true;
            this.form.put(`/caregivers/${this.selectedProvider.id}/contact`)
                .then( ({ data }) => {
                    this.items = this.mapItems(data.data);
                    this.contactModal = false;
                    this.busy = false;
                })
                .catch(e => {
                    console.log(e);
                    this.busy = false;
                })
        },
    },
};
</script>
